import { render, staticRenderFns } from "./paymentSuccess.vue?vue&type=template&id=497fa063&scoped=true&"
import script from "./paymentSuccess.vue?vue&type=script&lang=js&"
export * from "./paymentSuccess.vue?vue&type=script&lang=js&"
import style0 from "./paymentSuccess.vue?vue&type=style&index=0&id=497fa063&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "497fa063",
  null
  
)

export default component.exports